<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <b-overlay
        :show="__isOnLoad"
        variant="dark"
        rounded
        opacity="0.70"
        spinner-variant="primary"
        spinner-small
      >

      <div class="editionZonePanel">
        <div class="optionEditHead">
          <div>
            <div class="optionEditTitle">Edition de l'option</div>
            <div class="optionEditSubtitle">Mettez a jour le libelle puis enregistrez les changements.</div>
          </div>
          <div class="optionEditActions">
            <b-button size="sm" variant="danger" @click="dispatchCancel()">Fermer</b-button>
            <b-button size="sm" variant="success" @click="dispatchSave()" v-if="(errorCtrl.filter(e => e.isValid === false).length === 0)">Enregistrer</b-button>
          </div>
        </div>

        <div class="row optionEditBody" style="margin-right: 0px; margin-left: 0px;">
          <div class="col-md-12 pr-md-1">
              <base-input
                placeholder="Message"
                v-model="__item.name"
                ></base-input>
          </div>
        </div>

      </div>
    </b-overlay>
  </div>
</template>
<script>

import axios from 'axios'
export default {
  components: {

  },
  props: {
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => {
    return {
      errorCtrl: [],
      
    }
  },
  methods: {
    dispatchSave() {
      this.$parent.saveAction();
    },
    dispatchCancel() {
      this.$parent.cancelAction();
    },
  },
  mounted() {
  }
};
</script>
<style scoped>
.editionZonePanel {
    width: 100%;
    padding: 20px;
    margin-bottom: 10px;
    border-radius: 20px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
    border: 1px solid #dbe4f0;
}
.editionZoneParamsPanel {
    width: 100%;
    padding: 1%;
    margin-bottom: 10px;
    border-radius: 10px;
    background-color: #fff;
}
.form-group {
  margin-bottom: 0px;
}
.modal.show .modal-dialog {
  max-width: 90% !important;
}
.modal-content {
  background: #fff !important;
}

.optionEditHead {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 16px;
}

.optionEditTitle {
  color: #1e2a44;
  font-size: 20px;
  font-weight: 800;
}

.optionEditSubtitle {
  color: #64748b;
  font-size: 13px;
}

.optionEditActions {
  display: flex;
  gap: 10px;
}

@media (max-width: 767px) {
  .optionEditHead {
    flex-direction: column;
  }

  .optionEditActions {
    width: 100%;
  }

  .optionEditActions .btn {
    flex: 1 1 0;
  }
}
</style>
